import React, { useEffect } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import InvestmentTransactionBaseForm from './InvestmentTransactionBaseForm';
import { makeNumericKeyDownHandler, sanitizeNumericValue } from './numericInputHelpers';
import type { InvestmentTransactionFormikProps } from './types';

const handleNumericKeyDown = makeNumericKeyDownHandler();

const InvestmentTransactionDividentForm = (props: InvestmentTransactionFormikProps) => {
  const { formik } = props;

  useEffect(() => {
    formik.registerField('units', {
      validate: (value: number | null | undefined) =>
        typeof value === 'number' && value ? undefined : 'field is required',
    });
    return () => {
      formik.unregisterField('units');
    };
  }, [formik]);

  return (
    <>
      <InvestmentTransactionBaseForm formik={formik} />

      <Box display='flex'>
        <TextField
          id='units'
          label='Shares quantity'
          type='number'
          inputProps={{ min: 1, inputMode: 'decimal' }}
          sx={{ minWidth: 110 }}
          value={formik.values.units != null ? Math.abs(formik.values.units) : ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const sanitized = sanitizeNumericValue(event.target.value);
            formik.setFieldValue('units', sanitized ? Number(sanitized) : null);
          }}
          error={Boolean(formik.submitCount > 0 && formik.errors.units)}
          helperText={(formik.submitCount > 0 && formik.errors.units) || 'Total shares received for each shares held'}
        />
      </Box>
    </>
  );
};

export default InvestmentTransactionDividentForm;
